const CheckoutBookIcon = (props) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M0.833984 18V13.8333H2.50065V16.3333H5.00065V18H0.833984ZM15.0007 18V16.3333H17.5007V13.8333H19.1673V18H15.0007ZM3.33398 15.5V5.5H5.00065V15.5H3.33398ZM5.83398 15.5V5.5H6.66732V15.5H5.83398ZM8.33398 15.5V5.5H10.0007V15.5H8.33398ZM10.834 15.5V5.5H13.334V15.5H10.834ZM14.1673 15.5V5.5H15.0007V15.5H14.1673ZM15.834 15.5V5.5H16.6673V15.5H15.834ZM0.833984 7.16667V3H5.00065V4.66667H2.50065V7.16667H0.833984ZM17.5007 7.16667V4.66667H15.0007V3H19.1673V7.16667H17.5007Z" fill="black"/>
        </svg>
    )
}

export default CheckoutBookIcon;